// Data from here: https://github.com/aerrity/d3-cartogram/blob/master/data/ireland.topojson

export function topo2() {
	return {
		type: 'Topology',
		arcs: [
			[
				[4356, 9584],
				[-59, -60],
				[-87, -15],
				[-67, -99],
				[-11, -49],
				[8, -67],
				[-40, -56],
				[-16, -48],
				[6, -95],
				[-36, -103],
				[-97, -138],
				[-12, -102],
				[-86, -40],
				[-46, 14],
				[-71, -69],
				[-46, -30],
				[-46, -4],
				[-101, 67],
				[-46, -53],
				[-67, -38],
				[30, -27],
				[1, -67],
				[57, -32],
				[35, -47],
				[31, 21],
				[83, -66],
				[58, 26],
				[4, -53],
				[-56, -21],
				[-134, -146],
				[-52, -23],
				[-53, 2],
				[-102, 27],
				[-72, -121],
				[-56, -50],
				[-72, -24],
				[-7, -81],
				[102, -155],
				[66, -59],
				[39, 0],
				[29, -83],
				[40, -68],
				[76, -19],
				[28, -60],
				[6, -117],
				[44, -59],
				[74, -12],
				[104, 1],
				[97, -84],
				[32, -76],
				[144, -39],
				[29, 7],
				[55, 51],
				[34, -4],
				[33, -64],
				[108, -18],
				[-31, 75],
				[10, 31],
				[41, 28],
				[-3, -104],
				[46, 40],
				[3, 105],
				[43, 71],
				[74, 23],
				[28, 21],
				[-8, 44],
				[18, 30],
				[-48, 47],
				[8, 36],
				[-45, 26],
				[33, 62],
				[-1, 53],
				[35, -4],
				[44, 38],
				[65, 119],
				[40, 44],
				[42, 5],
				[46, -27],
				[83, -80],
				[22, -63],
				[35, -19],
				[31, -129],
				[-34, -42],
				[60, -44],
				[18, -74],
				[49, -78],
				[58, -50],
				[52, 39],
				[30, -12],
				[59, -70],
				[8, -47],
				[-43, -93],
				[12, -61],
				[-20, -62],
				[75, -82],
				[29, 40],
				[42, -9],
				[115, 49],
				[37, 2],
				[23, -35],
				[76, 21],
				[13, 90],
				[18, 36],
				[37, -34],
				[57, 19],
				[20, -19],
			],
			[
				[5673, 7015],
				[143, -163],
				[51, -16],
				[26, -44],
				[-5, -33],
				[-44, -60],
				[-57, 3],
				[-164, 85],
				[-55, -21],
				[-34, -104],
				[-8, -126],
				[8, -46],
				[30, -48],
				[45, -27],
				[100, -16],
				[-16, -113],
				[44, -69],
				[-28, -36],
				[-7, -71],
				[10, -185],
				[25, -105],
				[48, -42],
				[23, -65],
				[105, -75],
				[23, -99],
				[-67, -189],
				[-45, 12],
				[-49, -31],
				[86, -49],
				[28, -129],
				[80, -23],
				[-15, -47],
				[-55, 29],
				[-27, 38],
				[-46, -20],
				[-79, -72],
				[5, -51],
				[76, -104],
				[78, -37],
				[-11, -53],
				[8, -134],
				[38, -81],
				[-9, -47],
				[64, -146],
				[-12, -187],
				[-16, -82],
				[17, -41],
				[57, -77],
				[-34, -90],
				[-22, -29],
				[-46, -126],
				[10, -20],
				[-57, -66],
				[-31, -63],
				[-32, -126],
				[8, -58],
				[-28, -78],
				[-63, -134],
				[-6, -89],
				[18, -116],
				[-4, -113],
				[-17, -46],
				[-82, -162],
				[-47, -51],
				[-65, -144],
				[2, -94],
				[-113, -6],
				[-65, 23],
				[54, -76],
				[2, -62],
				[42, -11],
				[20, -50],
				[26, 17],
				[27, -61],
				[69, -84],
				[-39, -115],
				[-30, -46],
				[-40, 15],
				[25, 58],
				[-26, 9],
				[-35, -45],
				[-58, -1],
				[-28, 16],
				[-64, -16],
				[-57, -41],
				[-24, 4],
				[-60, 61],
				[-99, 37],
				[-96, -17],
				[-26, 27],
				[-26, -109],
				[-97, -72],
				[-47, -72],
				[-11, 49],
				[49, 50],
				[-23, 134],
				[-22, 43],
				[-45, 48],
				[1, -71],
				[-17, -65],
				[37, -25],
				[-61, -105],
				[-23, -22],
				[-91, -11],
				[-21, 21],
				[38, 62],
				[-65, 17],
				[19, -53],
				[-59, 12],
				[-24, -48],
				[-52, -15],
				[-51, 15],
				[-258, -33],
				[-93, -61],
				[-91, -40],
				[-14, 44],
				[-49, -32],
				[-17, -35],
				[104, -50],
				[4, -46],
				[-42, -37],
				[-10, -99],
				[-62, -38],
				[-71, 9],
				[-28, -17],
				[-19, -78],
				[-143, 24],
				[-37, -28],
				[-37, -63],
				[-51, -19],
				[40, -45],
				[1, -34],
				[-86, -31],
				[-71, -38],
				[-20, -33],
				[3, -52],
				[-102, -26],
				[-51, -24],
				[-85, -10],
				[-66, 4],
				[22, 90],
				[38, 14],
				[35, 40],
				[-36, 18],
				[-10, 55],
				[-45, 22],
				[-56, -3],
				[-11, 30],
				[-73, -30],
				[-83, 0],
				[17, -40],
				[56, -10],
				[34, -31],
				[-24, -83],
				[50, 6],
				[5, -64],
				[29, -14],
				[-27, -54],
				[4, -63],
				[-59, -89],
				[-36, -24],
				[-169, -61],
				[-32, -37],
				[-24, -80],
				[-26, -27],
				[-41, 21],
				[-66, -23],
				[-161, 20],
				[73, -74],
				[9, -107],
				[-51, 9],
				[-42, 27],
				[-119, 15],
				[-46, -106],
				[-55, -26],
				[-69, 39],
				[-125, -30],
				[-47, 0],
				[-28, -53],
				[-41, -19],
				[-46, 7],
				[-42, -99],
				[-56, 18],
				[-9, 38],
				[-85, -83],
				[-19, -8],
				[-37, 54],
				[-50, 44],
				[16, 92],
				[-31, 31],
				[-70, -60],
				[-95, -25],
				[-12, -46],
				[-33, 1],
				[-26, -31],
				[-38, -7],
				[-18, 56],
				[-29, -10],
				[-73, -82],
				[18, -18],
				[-139, -74],
				[-9, 74],
				[-27, 36],
				[54, 33],
				[72, 79],
				[47, 16],
				[54, 42],
				[59, 83],
				[102, 74],
				[-62, 7],
				[-261, -162],
				[-84, -8],
				[83, 64],
				[21, 50],
				[53, 22],
				[166, 110],
				[18, 35],
				[44, 7],
				[50, 32],
				[90, 36],
				[21, 79],
				[-20, 29],
				[-44, -27],
				[-49, 43],
				[1, 44],
				[-41, 3],
				[-13, -84],
				[-56, -64],
				[-55, -31],
				[-88, -12],
				[-47, -24],
				[-170, -29],
				[-75, -50],
				[-16, -42],
				[-85, -34],
				[-32, -32],
				[-56, 20],
				[-92, -27],
				[-7, 52],
				[92, 31],
				[17, 65],
				[-34, 58],
				[84, 1],
				[30, 16],
				[63, 74],
				[-55, 20],
				[23, 48],
				[88, 68],
				[41, -38],
				[38, 41],
				[3, 44],
				[41, -20],
				[14, 38],
				[102, 144],
				[90, 17],
				[122, 92],
				[-98, -16],
				[-141, -66],
				[-46, -53],
				[-44, 0],
				[-12, -28],
				[-56, -36],
				[-37, 20],
				[-64, -20],
				[-90, -74],
				[-30, 20],
				[-61, -69],
				[-36, -27],
				[-25, 22],
				[-128, 74],
				[52, 20],
				[12, 63],
				[-23, 68],
				[-55, 31],
				[-49, -78],
				[-94, -88],
				[-8, 34],
				[16, 77],
				[-8, 35],
				[-65, 7],
				[10, 84],
				[26, 25],
				[112, 48],
				[38, 27],
				[-59, 129],
				[49, 25],
				[-10, 39],
				[66, 27],
				[120, 79],
				[128, 33],
				[55, 39],
				[29, 90],
				[22, -68],
				[34, 20],
				[28, 156],
				[42, -30],
				[42, -2],
				[100, 16],
				[-28, 36],
				[47, 36],
				[-268, -18],
				[17, -54],
				[-72, 36],
				[-41, 3],
				[-181, -55],
				[-32, -24],
				[-43, 56],
				[-33, -29],
				[-34, 42],
				[-104, -29],
				[-95, -66],
				[-62, 9],
				[-23, 129],
				[37, 36],
				[1, 62],
				[45, -7],
				[47, -38],
				[17, 31],
				[-9, 77],
				[12, 41],
				[63, 17],
				[60, 88],
				[140, 50],
				[21, -22],
				[-13, -116],
				[88, 16],
				[75, 75],
				[27, 108],
				[22, -150],
				[82, -41],
				[102, -14],
				[47, 58],
				[37, -32],
				[97, 16],
				[-21, 26],
				[-62, 8],
				[-64, 36],
				[28, 92],
				[-15, 44],
				[4, 130],
				[-22, 27],
				[-72, 16],
				[-62, 54],
				[46, 36],
				[91, 7],
				[134, 75],
				[61, 71],
				[71, -12],
				[1, 39],
				[-44, 2],
				[15, 155],
				[32, 46],
				[41, 18],
				[55, -18],
				[107, 0],
				[37, -23],
				[43, 41],
				[107, -5],
				[117, 5],
				[70, 22],
				[37, 39],
				[165, 63],
				[60, -15],
				[47, 17],
				[42, 72],
				[236, 37],
				[21, 19],
				[-88, 42],
				[-45, 11],
				[-87, -17],
				[-23, 53],
				[-7, 100],
				[-21, 10],
				[2, 59],
				[-74, -63],
				[-3, -34],
				[-44, -99],
				[-119, -193],
				[-26, -16],
				[-120, -17],
				[-41, -54],
				[-64, 18],
				[73, 74],
				[-43, 4],
				[-98, -37],
				[-69, -3],
				[-55, 20],
				[-21, 38],
				[-46, 8],
				[-26, 78],
				[-49, -1],
				[38, -71],
				[-102, -57],
				[-89, -32],
				[-17, -67],
				[-32, 10],
				[-36, -32],
				[-242, -40],
				[82, 79],
				[70, 22],
				[273, 314],
				[-9, 36],
				[64, 42],
				[57, -3],
				[54, 27],
				[20, 80],
				[-11, 54],
				[29, 27],
				[55, 118],
				[2, 53],
				[84, 96],
				[-10, 61],
				[-106, -7],
				[-35, 15],
				[54, 70],
				[129, 292],
				[29, 37],
				[65, 147],
				[28, 14],
				[95, -93],
				[30, -15],
				[119, 62],
				[-78, 66],
				[79, 18],
				[62, -51],
				[26, 13],
				[8, 58],
				[47, -58],
				[37, -16],
				[-28, 90],
				[33, 92],
				[-134, 5],
				[5, 29],
				[61, 18],
				[1, 50],
				[53, 41],
				[-107, 18],
				[-74, -31],
				[-437, -42],
				[-63, -43],
				[-86, -9],
				[-29, 16],
				[-45, 72],
				[26, 46],
				[-32, 30],
				[-19, -106],
				[-37, -37],
				[-21, 51],
				[26, 55],
				[-11, 119],
				[59, 13],
				[17, 40],
				[-55, 62],
				[66, 54],
				[-73, -1],
				[0, -94],
				[-38, -51],
				[-24, 30],
				[19, 116],
				[-19, 20],
				[-43, -46],
				[-58, -130],
				[-21, -31],
				[-86, -34],
				[-49, 57],
				[-58, -16],
				[-16, 28],
				[15, 83],
				[62, 23],
				[55, 44],
				[-27, 38],
				[-54, -12],
				[-21, 56],
				[-48, 28],
				[-19, -43],
				[4, -54],
				[-52, -26],
				[-87, 15],
				[-32, 65],
				[-105, 0],
				[-19, 26],
				[-47, -18],
				[26, 71],
				[48, 20],
				[72, -9],
				[-26, 100],
				[-55, 72],
				[-33, 92],
				[61, 16],
				[-11, 55],
				[60, -1],
				[61, -19],
				[28, -51],
				[46, 51],
				[-82, 64],
				[31, 46],
				[105, -12],
				[103, 48],
				[42, -31],
				[65, -13],
				[105, -9],
				[-23, 31],
				[-94, -9],
				[-58, 26],
				[-110, 79],
				[-19, 118],
				[31, 141],
				[-12, 48],
				[147, 48],
				[22, 18],
				[42, -28],
				[250, 52],
				[-74, 56],
				[22, 58],
				[61, 68],
				[-36, 73],
				[-39, 16],
				[-192, 2],
				[-133, -88],
				[-73, -20],
				[-28, 70],
				[9, 74],
				[22, 19],
				[0, 71],
				[55, 38],
				[76, -52],
				[5, -62],
				[27, -6],
				[3, 82],
				[-37, 51],
				[-35, -7],
				[-21, 102],
				[-31, -1],
				[-29, 62],
				[2, 79],
				[48, 42],
				[-19, 25],
				[28, 98],
				[-84, -127],
				[-38, -9],
				[-34, 33],
				[-1, 68],
				[85, 37],
				[-41, 35],
				[-34, 115],
				[37, 33],
				[-69, 68],
				[-62, -75],
				[-7, -48],
				[-65, -20],
				[24, -39],
				[1, -108],
				[-21, -33],
				[-45, 13],
				[-14, 77],
				[38, 107],
				[12, 78],
				[42, 71],
				[-59, 11],
				[41, 114],
				[110, 83],
				[9, -45],
				[41, -31],
				[43, 13],
				[56, -36],
				[-30, -67],
				[-55, -57],
				[46, -31],
				[57, 63],
				[-19, 32],
				[9, 42],
				[42, 54],
				[77, -50],
				[11, 31],
				[-68, 72],
				[-20, 85],
				[79, 24],
				[106, -54],
				[231, -19],
				[67, 15],
				[29, -32],
				[107, -18],
				[68, 56],
				[99, -49],
				[18, -61],
				[38, 10],
				[13, -34],
				[-11, -50],
				[30, -17],
				[-20, -65],
				[65, -68],
				[97, 91],
				[23, 54],
				[10, 69],
				[20, 44],
				[45, 6],
				[82, -22],
				[24, 17],
				[91, -66],
				[86, -5],
				[57, 36],
				[38, -33],
				[82, 19],
				[38, -22],
				[20, -81],
				[38, -18],
				[44, -67],
				[83, 38],
				[-65, 34],
				[-17, 50],
				[-66, 24],
				[36, 74],
				[48, -22],
				[24, 24],
				[74, 12],
				[-62, 57],
				[17, 43],
				[-58, 30],
				[-134, 0],
				[-3, 56],
				[69, 43],
				[156, 127],
				[31, 17],
				[10, 119],
				[32, -73],
				[79, 56],
				[131, 29],
				[61, 49],
				[-2, 33],
				[-37, 35],
				[73, 71],
				[-3, 51],
				[62, 65],
				[-4, 66],
				[51, -36],
				[23, 108],
				[-62, -27],
				[-92, -18],
				[-49, -46],
				[-21, 65],
				[-40, -3],
				[-35, -51],
				[-34, -20],
				[-63, -80],
				[-3, 44],
				[43, 28],
				[-20, 61],
				[-43, 33],
				[-34, -86],
				[-20, -2],
				[-39, 64],
				[-71, -25],
				[-14, -37],
				[-45, 28],
				[-102, 0],
				[-25, 58],
				[-112, 49],
				[-29, 102],
				[39, 10],
				[45, 81],
				[96, 79],
				[35, 16],
				[135, -4],
				[9, 55],
				[76, -3],
				[38, -62],
				[50, -2],
				[-72, 82],
				[-51, 20],
				[-74, 70],
				[39, 10],
				[46, 55],
				[27, -31],
				[93, 11],
				[28, 30],
				[20, 67],
				[53, -11],
				[-13, 70],
				[-43, 12],
				[-16, -58],
				[-39, 2],
				[-31, 39],
				[-42, 104],
				[61, -17],
				[30, 55],
				[-82, 106],
				[26, 38],
				[30, -18],
				[16, 73],
				[40, 15],
				[26, 64],
				[67, -6],
				[-21, 124],
				[22, 37],
				[21, 82],
				[34, 29],
				[77, -37],
				[87, 36],
				[-24, -58],
				[20, -23],
				[40, 65],
				[127, 90],
				[29, 82],
				[30, 6],
				[36, -31],
				[-16, -61],
				[18, -19],
				[54, 22],
				[19, -37],
				[-6, -47],
				[57, -46],
				[30, 68],
				[-34, 79],
				[-9, 53],
				[91, 109],
				[10, -19],
				[-31, -124],
				[12, -47],
				[47, 11],
				[72, -57],
				[25, -70],
				[41, 18],
				[-47, 189],
				[-28, -10],
				[20, -107],
				[-55, 54],
				[-56, 30],
				[41, 117],
				[70, 15],
				[48, 47],
				[40, -2],
				[44, -83],
				[-12, -97],
				[25, -41],
				[39, -22],
				[27, -96],
				[34, -32],
				[-6, -87],
				[-73, -76],
				[-74, -54],
				[81, -1],
				[26, -15],
				[-15, -56],
				[-83, -74],
				[-45, -72],
				[33, -8],
				[153, 173],
				[82, 35],
				[25, 75],
				[-37, 64],
				[20, 61],
				[-10, 68],
				[-54, 95],
				[-42, 45],
				[-11, 72],
				[30, 30],
				[19, 100],
				[86, 52],
				[59, -19],
				[51, 63],
				[55, -6],
				[20, -48],
				[48, -38],
				[27, 21],
				[-86, 78],
				[-41, 58],
				[-3, 61],
				[-63, 58],
				[21, 16],
				[70, -36],
				[115, -41],
				[70, -49],
				[69, -119],
				[87, -56],
				[51, -10],
				[138, -79],
				[-5, -54],
				[-40, -27],
				[-83, -30],
				[-88, -83],
				[-81, -39],
				[-77, -112],
				[-41, -104],
			],
			[
				[1099, 4840],
				[33, -65],
				[-27, -49],
				[-46, -16],
				[-24, 32],
				[-13, 73],
				[29, 38],
				[48, -13],
			],
			[
				[694, 6634],
				[55, 0],
				[-20, -80],
				[1, -82],
				[-29, -32],
				[-81, 86],
				[-50, 2],
				[-1, 119],
				[-42, 33],
				[-102, -26],
				[-37, 6],
				[-102, 48],
				[64, 11],
				[49, 64],
				[35, 15],
				[29, -41],
				[35, 11],
				[61, 48],
				[118, -4],
				[26, -14],
				[27, -70],
				[-24, -22],
				[-12, -72],
			],
			[
				[2633, 9427],
				[38, -24],
				[17, -67],
				[-58, -21],
				[-52, 21],
				[0, 53],
				[55, 38],
			],
			[
				[891, 511],
				[5, -30],
				[-106, -43],
				[-35, 21],
				[23, 46],
				[58, 15],
				[55, -9],
			],
			[
				[223, 1269],
				[-13, -59],
				[-53, -29],
				[-91, -6],
				[23, 37],
				[82, 72],
				[52, -15],
			],
			[
				[1119, 4380],
				[-17, -29],
				[-159, 87],
				[-44, 37],
				[46, 24],
				[34, -30],
				[49, 8],
				[60, -21],
				[-1, -56],
				[32, -20],
			],
			[
				[4356, 9584],
				[-13, -49],
				[83, 20],
				[83, -38],
				[92, 0],
				[65, 72],
				[-1, 34],
				[27, 92],
				[31, 44],
				[8, 120],
				[30, 39],
				[85, -56],
				[174, 9],
				[154, 81],
				[93, 8],
				[69, 78],
				[60, 21],
				[81, -45],
				[50, 38],
				[34, -9],
				[131, -84],
				[52, -1],
				[77, 30],
				[80, -25],
				[86, -118],
				[-5, -148],
				[-28, -100],
				[10, -24],
				[68, -5],
				[38, -27],
				[7, -72],
				[-24, -98],
				[78, -47],
				[59, -79],
				[23, -81],
				[53, -67],
				[22, -59],
				[18, -111],
				[90, -41],
				[-86, 104],
				[21, 45],
				[41, -13],
				[67, -85],
				[16, -83],
				[-3, -74],
				[-20, -59],
				[-30, -38],
				[-156, -72],
				[-61, -77],
				[-50, -104],
				[44, -74],
				[75, 119],
				[123, 81],
				[72, -31],
				[162, 30],
				[51, -60],
				[30, -158],
				[48, -75],
				[14, -140],
				[42, -76],
				[5, -57],
				[-42, -108],
				[5, -88],
				[-38, -59],
				[-17, -80],
				[-35, 15],
				[-26, 90],
				[-40, 62],
				[7, 61],
				[31, 45],
				[1, 123],
				[-37, 105],
				[-94, 103],
				[-36, 24],
				[-46, -91],
				[89, -124],
				[-7, -62],
				[26, -30],
				[0, -52],
				[-48, -163],
				[53, -8],
				[57, 19],
				[39, -48],
				[13, -101],
				[-16, -76],
				[-81, -114],
				[-27, 0],
				[-31, -68],
				[-31, 43],
				[-78, 8],
				[-57, -7],
				[-112, -42],
				[-8, -32],
				[-1, -151],
				[-19, -108],
				[-39, -77],
				[-57, -34],
				[-41, -51],
				[-75, -61],
				[-53, -5],
				[-45, 25],
				[38, 35],
				[-121, 46],
				[-15, 48],
				[-36, 15],
				[-78, -1],
			],
			[
				[5719, 10225],
				[69, -12],
				[18, -36],
				[-120, 4],
				[33, 44],
			],
		],
		transform: {
			scale: [0.0007417612739303036, 0.00037807481799865693],
			translate: [-10.478179490999935, 51.44570547100005],
		},
		objects: {
			countries: {
				type: 'GeometryCollection',
				geometries: [
					{
						arcs: [[[0, 1]], [[2]], [[3]], [[4]], [[5]], [[6]], [[7]]],
						type: 'MultiPolygon',
						properties: { ADM0_A3: 'IRL', SU_A3: 'IRL', NAME_EN: 'Ireland' },
					},
					{
						arcs: [[[8, -1]], [[9]]],
						type: 'MultiPolygon',
						properties: {
							ADM0_A3: 'GBR',
							SU_A3: 'NIR',
							NAME_EN: 'Northern Ireland',
						},
					},
				],
			},
			places: {
				type: 'GeometryCollection',
				geometries: [
					{
						type: 'Point',
						coordinates: [3094, 5786],
						properties: { ADM0_A3: 'IRL', SOV_A3: 'IRL', name_en: 'Roscommon' },
					},
					{
						type: 'Point',
						coordinates: [4734, 7417],
						properties: { ADM0_A3: 'IRL', SOV_A3: 'IRL', name_en: 'Monaghan' },
					},
					{
						type: 'Point',
						coordinates: [2176, 3328],
						properties: { ADM0_A3: 'IRL', SOV_A3: 'IRL', name_en: 'Shannon' },
					},
					{
						type: 'Point',
						coordinates: [4538, 2149],
						properties: { ADM0_A3: 'IRL', SOV_A3: 'IRL', name_en: 'Waterford' },
					},
					{
						type: 'Point',
						coordinates: [1027, 2171],
						properties: { ADM0_A3: 'IRL', SOV_A3: 'IRL', name_en: 'Tralee' },
					},
					{
						type: 'Point',
						coordinates: [3184, 8475],
						properties: { ADM0_A3: 'IRL', SOV_A3: 'IRL', name_en: 'Donegal' },
					},
					{
						type: 'Point',
						coordinates: [5568, 6014],
						properties: { ADM0_A3: 'IRL', SOV_A3: 'IRL', name_en: 'Drogheda' },
					},
					{
						type: 'Point',
						coordinates: [5475, 6757],
						properties: { ADM0_A3: 'IRL', SOV_A3: 'IRL', name_en: 'Dundalk' },
					},
					{
						type: 'Point',
						coordinates: [1927, 4832],
						properties: { ADM0_A3: 'IRL', SOV_A3: 'IRL', name_en: 'Galway' },
					},
					{
						type: 'Point',
						coordinates: [4349, 3197],
						properties: { ADM0_A3: 'IRL', SOV_A3: 'IRL', name_en: 'Kilkenny' },
					},
					{
						type: 'Point',
						coordinates: [1296, 1599],
						properties: { ADM0_A3: 'IRL', SOV_A3: 'IRL', name_en: 'Killarney' },
					},
					{
						type: 'Point',
						coordinates: [2689, 7462],
						properties: { ADM0_A3: 'IRL', SOV_A3: 'IRL', name_en: 'Sligo' },
					},
					{
						type: 'Point',
						coordinates: [2673, 1198],
						properties: { ADM0_A3: 'IRL', SOV_A3: 'IRL', name_en: 'Cork' },
					},
					{
						type: 'Point',
						coordinates: [2501, 3224],
						properties: { ADM0_A3: 'IRL', SOV_A3: 'IRL', name_en: 'Limerick' },
					},
					{
						type: 'Point',
						coordinates: [5699, 4997],
						properties: { ADM0_A3: 'IRL', SOV_A3: 'IRL', name_en: 'Dublin' },
					},
				],
			},
		},
	};
}
